import { keyBy, map, reduce, uniq } from "lodash";

import applyVersion2Sync from "./groups/applyVersion2Sync";
import buildATimeline from "./groups/buildATimeline";
import dependenciesAndConstraints from "./groups/dependenciesAndConstraints";
import exportWritingProject from "./groups/exportWritingProject";
import filterAndCompare from "./groups/filterAndCompare";
import getComfortableWithVersion3 from "./groups/getComfortableWithVersion3";
import importWritingProject from "./groups/importWritingProject";
import relatePeopleAndPlaces from "./groups/relatePeopleAndPlaces";
import spreadsheetView from "./groups/spreadsheetView";
import storyToTimeline from "./groups/storyToTimeline";
import tellAStory from "./groups/tellAStory";
import timelineCustomization from "./groups/timelineCustomization";
import tutorialPaths from "./tutorialPaths";

const newUserNoSync = [
  buildATimeline,
  relatePeopleAndPlaces,
  tellAStory,
  filterAndCompare,
  dependenciesAndConstraints,
  timelineCustomization,
  //#!if iOS !== true
  exportWritingProject
  //#!endif
];

const newUserWithSync = [
  importWritingProject,
  storyToTimeline,
  relatePeopleAndPlaces,
  filterAndCompare,
  spreadsheetView,
  timelineCustomization,
  dependenciesAndConstraints
];

const existingUserNoSync = [
  getComfortableWithVersion3,
  spreadsheetView,
  tellAStory,
  filterAndCompare,
  dependenciesAndConstraints,
  timelineCustomization,
  //#!if iOS !== true
  exportWritingProject
  //#!endif
];

const existingUserWithSync = [
  applyVersion2Sync,
  getComfortableWithVersion3,
  spreadsheetView,
  filterAndCompare,
  dependenciesAndConstraints,
  timelineCustomization
];

const allGroups = uniq([...newUserNoSync, ...newUserWithSync, ...existingUserNoSync, ...existingUserWithSync]);

const byId = keyBy(allGroups, "id");

const allIds = map(allGroups, g => g.id);

const allIdsByPath = {
  [tutorialPaths.NEW_USER_NO_SYNC]: map(newUserNoSync, g => g.id),
  [tutorialPaths.NEW_USER_WITH_SYNC]: map(newUserWithSync, g => g.id),
  [tutorialPaths.EXISTING_USER_NO_SYNC]: map(existingUserNoSync, g => g.id),
  [tutorialPaths.EXISTING_USER_WITH_SYNC]: map(existingUserWithSync, g => g.id)
};

export const tutorialAccessGatesById = reduce(
  allGroups,
  (result, g) => {
    g.tips.forEach(t => {
      if (t.accessGate) {
        result[t.id] = t.accessGate;
      }
    });
    if (g.accessGate) {
      result[g.id] = g.accessGate;
    }
    return result;
  },
  {}
);

export const tutorialApplicableGatesById = reduce(
  allGroups,
  (result, g) => {
    if (g.applicableGate) {
      result[g.id] = g.applicableGate;
    }
    return result;
  },
  {}
);

export const tutorialDismissalGatesById = reduce(
  allGroups,
  (result, g) => {
    g.tips.forEach(t => {
      if (t.dismissalGate) {
        result[t.id] = t.dismissalGate;
      }
    });
    return result;
  },
  {}
);

export const tutorialLinksById = reduce(
  allGroups,
  (result, g) => {
    if (g.links) {
      result[g.id] = g.links;
    }
    return result;
  },
  {}
);

export const tutorialResolutionById = reduce(
  allGroups,
  (result, g) => {
    g.tips.forEach(t => {
      if (t.resolve) {
        result[t.id] = t.resolve;
      }
    });
    return result;
  },
  {}
);

export const tutorialGroupById = reduce(
  allGroups,
  (result, g) => {
    g.tips.forEach(t => {
      result[t.id] = g.id;
    });
    return result;
  },
  {}
);

export const tutorialGroups = {
  byId,
  allIds,
  allIdsByPath
};
